import { StateService, TransitionService } from "angular-ui-router";

/**
 * Attach handlers for situations where the web app needs to be reloaded
 * due to the dist folder being updated on the server.
 */
export function attachAppUpdateTransitions($state: StateService, $transitions: TransitionService) {
    'ngInject';
    $transitions.onError({}, transition => {
        const ex = transition.error().detail;
        if (isChunkLoadError(ex)) {
            // The app lazy-loading config has gone stale, so transition to a dedicated state for updating the app.
            $state.go("appOutdated", { targetState: transition.to() });
        }
    });
}

/**
 * Identify whether the given exception indicates a chunk load error.
 * @param ex The exception to be analyzed.
 */
export function isChunkLoadError(ex: any) {
    return ex.name === "ChunkLoadError" || ex.code === "CSS_CHUNK_LOAD_FAILED";
}
